import { signal } from "@preact/signals-react";
import { useEffect } from "react";
import { addNotification } from "../stores/notification-store";

const manifest = signal(null)
const error = signal(null)
const loading = signal(false)
const isLoaded = signal(false)

const fetchData = async () => {
    // short-circuit if we have a pending request or have already received an error
    if (loading.value || error.value) {
        return
    }

    // short-circuit if we alreaady have the data
    if (manifest.value && isLoaded.value) {
        return
    }

    try {
        loading.value = true

        let response = await fetch('/schemas/schemamanifest.json')
        let data = await response.json()
        manifest.value = data
        isLoaded.value = true
    }
    catch(err) {
        error.value = err
        console.log(err)
        addNotification(`Unable to load schema manifest: ${err}`)
    }
    finally {
        loading.value = false
    }
}

const useSchemaManifest = () => {
    useEffect(() => {
        fetchData()
    }) // run effect everytime

    return {
        manifest, loading, isLoaded, error
    }
}

export default useSchemaManifest
